import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import { Sidebar } from './Sidebar';
import { BottomNav } from './BottomNav';
import { RightSidebar } from './RightSidebar';
import { MobileHeader } from './MobileHeader';

export function MainLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      {/* Mobile Header - Only visible on mobile */}
      <MobileHeader />

      {/* Desktop Sidebar - Hidden on mobile */}
      <Sidebar 
        collapsed={sidebarCollapsed} 
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} 
      />

      {/* Main Content Area */}
      <main
        className={`
          transition-all duration-300 ease-in-out
          pt-14 pb-24
          md:pt-0 md:pb-0
          ${sidebarCollapsed ? 'md:ml-20' : 'md:ml-64'}
          xl:mr-80
        `}
      >
        <div className="max-w-2xl mx-auto px-4 py-4 md:py-6">
          <Outlet />
        </div>
      </main>

      {/* Right Sidebar - Only visible on xl screens */}
      <RightSidebar />

      {/* Mobile Bottom Navigation */}
      <BottomNav />
    </div>
  );
}
